/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smpte_Format_PlaceholderInputs */

const en_smpte_format_placeholder = /** @type {(inputs: Smpte_Format_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMPTE Format (e.g. hh:mm:ss:ff)`)
};

const fr_smpte_format_placeholder = /** @type {(inputs: Smpte_Format_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format SMPTE (ex. hh:mm:ss:ff)`)
};

const de_smpte_format_placeholder = /** @type {(inputs: Smpte_Format_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMPTE-Format (z. B. hh:mm:ss:ff)`)
};

const it_smpte_format_placeholder = /** @type {(inputs: Smpte_Format_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato SMPTE (ad esempio hh:mm:ss:ff)`)
};

const ru_smpte_format_placeholder = /** @type {(inputs: Smpte_Format_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Формат SMPTE (например, hh:mm:ss:ff)`)
};

const es_smpte_format_placeholder = /** @type {(inputs: Smpte_Format_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato SMPTE (p. ej. hh:mm:ss:ff)`)
};

const zh_cn2_smpte_format_placeholder = /** @type {(inputs: Smpte_Format_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMPTE 格式（例如 hh:mm:ss:ff）`)
};

const ja_smpte_format_placeholder = /** @type {(inputs: Smpte_Format_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMPTE形式（例：hh:mm:ss:ff）`)
};

const hi_smpte_format_placeholder = /** @type {(inputs: Smpte_Format_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMPTE प्रारूप (उदाहरण के लिए hh:mm:ss:ff)`)
};

const pt_pt2_smpte_format_placeholder = /** @type {(inputs: Smpte_Format_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato SMPTE (ex.: hh:mm:ss:ff)`)
};

/**
* | output |
* | --- |
* | "SMPTE Format (e.g. hh:mm:ss:ff)" |
*
* @param {Smpte_Format_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const smpte_format_placeholder = /** @type {((inputs?: Smpte_Format_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smpte_Format_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_smpte_format_placeholder(inputs)
	if (locale === "de") return de_smpte_format_placeholder(inputs)
	if (locale === "it") return it_smpte_format_placeholder(inputs)
	if (locale === "ru") return ru_smpte_format_placeholder(inputs)
	if (locale === "es") return es_smpte_format_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_smpte_format_placeholder(inputs)
	if (locale === "ja") return ja_smpte_format_placeholder(inputs)
	if (locale === "hi") return hi_smpte_format_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_smpte_format_placeholder(inputs)
	return en_smpte_format_placeholder(inputs)
});